import { createReducer } from '@reduxjs/toolkit';

import {
  ActionSuccessType,
  ARCHIVE_EXPERT_VOLUNTEERING,
  CREATE_EXPERT_VOLUNTEERING,
  GET_EXPERT_VOLUNTEERINGS,
  PAUSE_EXPERT_VOLUNTEERING,
  RESUME_EXPERT_VOLUNTEERING,
  UPDATE_EXPERT_VOLUNTEERING,
} from 'constants/redux-actions';

const initState = [];

const replaceByResponseId = (prevState, action) => {
  const { id } = action.payload.data;

  return prevState.map((volunteering) => (volunteering.id === id ? action.payload.data : volunteering));
};

const expertVolunteeringsReducer = createReducer(initState, {
  [ActionSuccessType(GET_EXPERT_VOLUNTEERINGS)]: (_, action) => action.payload.data,
  [ActionSuccessType(UPDATE_EXPERT_VOLUNTEERING)]: replaceByResponseId,
  [ActionSuccessType(PAUSE_EXPERT_VOLUNTEERING)]: replaceByResponseId,
  [ActionSuccessType(RESUME_EXPERT_VOLUNTEERING)]: replaceByResponseId,
  [ActionSuccessType(ARCHIVE_EXPERT_VOLUNTEERING)]: replaceByResponseId,
  [ActionSuccessType(CREATE_EXPERT_VOLUNTEERING)]: (prevState, action) => [action.payload.data, ...prevState],
});

export default expertVolunteeringsReducer;
